export default function FertilityMonitor() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 25'
      fill='none'
      height='24'
      width='24'
      className='w-[36px] md:w-[24px]'
    >
      <path
        d='M8.55691 3.97248C13.1479 2.07048 18.4109 4.25148 20.3129 8.84248C22.2149 13.4335 20.0339 18.6965 15.4429 20.5985C10.8519 22.5005 5.58891 20.3195 3.68691 15.7285C1.78591 11.1375 3.96591 5.87448 8.55691 3.97248'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.7188 8.27051V12.9215L15.3747 15.1505'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
